const PROCORE_SIDE_PANEL_SET_PINS_COMPANY_ID = 'PROCORE_SIDE_PANEL_SET_PINS_COMPANY_ID';

export const setProcoreSidePanelPinsCompanyId = ({ pinsCompanyId = null }) => dispatch => {
  dispatch({ type: PROCORE_SIDE_PANEL_SET_PINS_COMPANY_ID, pinsCompanyId });
};

const PROCORE_SIDE_PANEL_SET_PROCORE_STATE = 'PROCORE_SIDE_PANEL_SET_PROCORE_STATE';

export const setProcoreSidePanelState = ({
  procoreCompanyId = null,
  procoreProjectId = null,
  procoreResourceId = null,
  procoreView = null
}) => dispatch => {
  dispatch({
    type: PROCORE_SIDE_PANEL_SET_PROCORE_STATE,
    procoreCompanyId,
    procoreProjectId,
    procoreResourceId,
    procoreView
  });
};

const PROCORE_SIDE_PANEL_SET_PROCORE_USER = 'PROCORE_SIDE_PANEL_SET_PROCORE_USER';

export const setProcoreSidePanelProcoreUser = ({
  procoreUser = null,
  procoreAccessToken = null,
  pinsAccessToken = null,
  pinsUser = null
}) => dispatch => {
  dispatch({
    type: PROCORE_SIDE_PANEL_SET_PROCORE_USER,
    procoreUser,
    procoreAccessToken,
    pinsAccessToken,
    pinsUser
  });
};

const DEFAULT_STATE = {
  procoreUser: null,
  pinsUser: null,
  pinsAccessToken: null,
  procoreAccessToken: null,
  procoreCompanyId: null,
  procoreProjectId: null,
  procoreResourceId: null,
  procoreView: null,
  pinsCompanyId: null
};

const procoreSidePanelReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case PROCORE_SIDE_PANEL_SET_PINS_COMPANY_ID:
      return {
        ...state,
        pinsCompanyId: action.pinsCompanyId ?? state.pinsCompanyId
      };
    case PROCORE_SIDE_PANEL_SET_PROCORE_STATE:
      return {
        ...state,
        procoreCompanyId: action.procoreCompanyId ?? state.procoreCompanyId,
        procoreProjectId: action.procoreProjectId ?? state.procoreProjectId,
        procoreResourceId: action.procoreResourceId ?? state.procoreResourceId,
        procoreView: action.procoreView ?? state.procoreView
      };
    case PROCORE_SIDE_PANEL_SET_PROCORE_USER:
      return {
        ...state,
        procoreUser: action.procoreUser ?? state.procoreUser,
        procoreAccessToken: action.procoreAccessToken ?? state.procoreAccessToken,
        pinsAccessToken: action.pinsAccessToken ?? state.pinsAccessToken,
        pinsUser: action.pinsUser ?? state.pinsUser
      };
    default:
      return state;
  }
};

export const selectProcoreSidePanelData = state => state.procoreSidePanel;

export default procoreSidePanelReducer;
